import { render, staticRenderFns } from "./WuYeNoticeManagement.vue?vue&type=template&id=618d4da5&scoped=true&"
import script from "./WuYeNoticeManagement.vue?vue&type=script&lang=js&"
export * from "./WuYeNoticeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d4da5",
  null
  
)

export default component.exports